module.exports = __webpack_public_path__ + "img/bundles-unactive.491afbe.svg";